import React from 'react';
import { IContainerReactRenderer, IRendererResult } from './IContainerReactRenderer';
import { TextContainer } from '../../model/containers/TextContainer';
import { IConversationRun } from '../../model/ConversationRun';
import { ScreenshotRequestAction } from '../uiManager/messages/ScreenshotRequestAction';

export class ScreenshotRequestContainerRenderer implements IContainerReactRenderer<TextContainer> {
    render(run: IConversationRun): IRendererResult {
        return {
            userActions: <ScreenshotRequestAction run={run} />,
        };
    }
}
